import { render, staticRenderFns } from "./equipmentRecordByYear.vue?vue&type=template&id=4ca8b256"
import script from "./equipmentRecordByYear.vue?vue&type=script&lang=js"
export * from "./equipmentRecordByYear.vue?vue&type=script&lang=js"
import style0 from "./equipmentRecordByYear.vue?vue&type=style&index=0&id=4ca8b256&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca8b256')) {
      api.createRecord('4ca8b256', component.options)
    } else {
      api.reload('4ca8b256', component.options)
    }
    module.hot.accept("./equipmentRecordByYear.vue?vue&type=template&id=4ca8b256", function () {
      api.rerender('4ca8b256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspection/equipmentRecordByYear.vue"
export default component.exports